import { render, staticRenderFns } from "./GatheringHome.vue?vue&type=template&id=0f2818e7&scoped=true&lang=html&"
import script from "./GatheringHome.vue?vue&type=script&lang=coffee&"
export * from "./GatheringHome.vue?vue&type=script&lang=coffee&"
import style0 from "./GatheringHome.vue?vue&type=style&index=0&id=0f2818e7&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2818e7",
  null
  
)

component.options.__file = "GatheringHome.vue"
export default component.exports